import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MibButtonComponent } from '@medinbox/angular';

@Component({
  selector: 'app-not-found-page',
  imports: [MibButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './not-found-page.component.html',
})
export class NotFoundPageComponent {}
